import { render } from "./ShopCreate.vue?vue&type=template&id=9b99d93c&ts=true"
import script from "./ShopCreate.vue?vue&type=script&lang=ts"
export * from "./ShopCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__